// Scroll to top button
const scrollBtn = document.querySelector('.page-footer__scroll-up');
const searchIcon = document.querySelector('.search-icon-js');
const distributorBtn = document.querySelector('.btn-become-a-distributor-heading');
const searchModalOverlay = document.querySelector('.search-overlay');
const searchModal = document.querySelector('.search-modal');
const distributorModal = document.querySelector('.distributor-modal');
const clearSearchButton = document.querySelector('.search-form__btn');
const body = document.querySelector('.page-body');
const burger = document.querySelector('.burger-js');
const burgerClose = document.querySelector('.close-menu-btn-js');
const mobileSocialsBtn = document.querySelectorAll('.socials-mobile-btn-js');

// Scroll Up button
scrollBtn.onclick = element => {
    element.preventDefault();

    $('html, body').animate({ scrollTop: 0 }, '1000');
}

const openModalDistributor = () => {
    searchModalOverlay.classList.add('show');

    setTimeout(() => {
        distributorModal.classList.add('show');
        body.classList.add('ovf');
    }, 100);
};

// Search Header Modal
const openModalSearch = () => {
    searchModalOverlay.classList.add('show');

    setTimeout(() => {
        searchModal.classList.add('show');
        body.classList.add('ovf');
    }, 100);
};

const closeModalSearch = () => {
    searchModal.classList.remove('show');
    body.classList.remove('ovf');

    setTimeout(() => {
        searchModalOverlay.classList.remove('show');
    }, 100);
};

if (searchIcon && clearSearchButton) {
    clearSearchButton.onclick = () => { closeModalSearch() };
    searchIcon.onclick = () => { openModalSearch() };
}

if (distributorBtn)
    distributorBtn.onclick = () => { openModalDistributor() };

// Burger
if (burger && burgerClose) {
    burger.onclick = () => {
        document.querySelector('.page-header__navigation-wrap-mob').classList.add('show');
        body.classList.add('ovf');

        setTimeout(() => {
            document.querySelector('.main-nav--mob').classList.add('up');
        }, 100);
    }

    burgerClose.onclick = () => {
        document.querySelector('.main-nav--mob').classList.remove('up');

        setTimeout(() => {
            document.querySelector('.page-header__navigation-wrap-mob').classList.remove('show');
            body.classList.remove('ovf');
        }, 200);
    }
}

// mobile socials
if (mobileSocialsBtn)
    mobileSocialsBtn.forEach(button => {
        button.onclick = element => {
            element.currentTarget.classList.toggle('show');
            element.currentTarget.parentNode.querySelector('.socials-mobile__list').classList.toggle('show');

            if (element.currentTarget.classList.contains('show')) {
                element.currentTarget.querySelector('.socials-mobile__open-btn-close-icon').style.display = 'block';
                element.currentTarget.querySelector('.socials-mobile__open-btn-open-icon').style.display = 'none';
            } else {
                element.currentTarget.querySelector('.socials-mobile__open-btn-close-icon').style.display = 'none';
                element.currentTarget.querySelector('.socials-mobile__open-btn-open-icon').style.display = 'block';
            }
        }
    });

document.addEventListener('wpcf7mailsent', function (event) {
    if (!event.target)
        return;

    const args = {
        'event': 'cf7submission',
        'formId': event.target.id,
        'response': event.detail.inputs,
    }

    console.log(args)

    window.dataLayer.push(args)
});

//Top Fast Up Hero Slider
const ticker = document.querySelector(".js-ticker");
const list = document.querySelector(".js-ticker__list");
if (ticker) {
    const clone = list.cloneNode(true);
    const secondClone = list.cloneNode(true);

    ticker.append(clone);
    ticker.append(secondClone);
}

jQuery(document).ready(function ($) {
    const postCats = $('.js-posts-cats');
    if (postCats) {
        $(document).on('click', '.js-post-cats-open', function (e) {
            console.log('before-prevent');
            e.preventDefault();
            $('.posts-cats--inner').toggleClass('slide-up');
            console.log('after-prevent');
        });
    }
});
